
import React from "react";
import ReactDOM from "react-dom";
import { createBrowserHistory } from "history";
import { Router, Route, Switch } from "react-router-dom";

// core components
import Admin from "layouts/Admin.js";
import customer from "layouts/Customer.js";


import LandingPage from "views/LandingPage/LandingPage";

import "assets/css/material-dashboard-react.css?v=1.9.0";
import "bootstrap/dist/css/bootstrap.min.css";
import Login from "views/Login/login";
import customerlogin from "views/CustomerPanel/CustomerLogin/Customerlogin.js";
import customerregistration from "views/CustomerPanel/CustomerSignUp/CustomerRegistration.js"
import Event from "views/Events/Event";

const hist = createBrowserHistory();

ReactDOM.render(
  <Router history={hist}>
    <Switch>
    <Route path="/admin" component={Admin} />
      <Route path="/login" component={Login} />
      <Route path="/customerlogin" component={customerlogin} />
      <Route path="/customerregistration" component={customerregistration} />
      <Route path="/admin-event" component={Event} />
      <Route path="/customer" component={customer} />
      <Route path="/" component={LandingPage} />
     <Route path="*" component={LandingPage}/>

    </Switch>
  </Router>,
  document.getElementById("root")
);
